import { TableContainer } from "@material-ui/core";
import { Link } from "react-router-dom";
import styled, { FlattenSimpleInterpolation, createGlobalStyle, css } from "styled-components";
import { OrderStatus } from "../../../../models/Order";

export const SearchOrderWrap = styled.div`
	border: 1px solid #b6b6b6;
	background-color: #fff;
	border-radius: 4px;
	position: relative;
	height: 40px;
	width: 100%;
	@media screen and (max-width: 768px) {
		margin-bottom: 12px;
		width: 100%;
	}
`;
export const SearchProductBoxSearchBtn = styled.button`
	height: 100%;
	font-size: 14px;
	color: white;
	border: none;
	cursor: pointer;
	background-color: #fff;
	padding: 8px 16px;
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
}
}
`;

export const SearchProductBoxDeleteInputBtn = styled.button`
	position: absolute;
	top: calc(50% - 12px);
	display: flex;
	align-items: center;
	right: 18px;
	background: transparent;
	height: 24px;
	font-size: 18px;
	color: var(--text-color0);
	border: none;
	cursor: pointer;
	@media screen and (max-width: 768px) {
		right: 18px;
	}
	& img {
		width: 14px;
	}
`;

export const InputSearchOrder = styled.input`
	border: none;
	outline: none;
	font-size: 14px;
	::placeholder {
		color: #a3a3a3;
	}
	@supports (-webkit-overflow-scrolling: touch) {
		& {
			font-size: 16px;
		}
	}
	font-family: inherit;
`;
export const SearchIcon = styled.i`
	font-size: 18px;
	color: #7cc246;
	@media screen and (max-width: 768px) {
		margin-right: 6px;
		font-size: 18px;
	}
`;

export const UserFilterWrap = styled.div`
	padding: 8px 0;
	@media screen and (max-width: 768px) {
		margin-right: 6px;
		font-size: 18px;
	}
`;
